import React from "react";
import Error from "../components/error";

function Error404() {
    return (
        <div>
            <Error
                error={"404"}
                errorDescription={"The page you are looking for cannot be found or does not exist."}
            />
        </div>
    );
}

export default Error404;
